import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography } from '@mui/material';

const Register = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (event) => {
    event.preventDefault();

    try {
      // Ensure email is always sent in lowercase
      const lowerCaseEmail = email.toLowerCase();

      const response = await fetch(
        'https://api.axillonaerospace.info/api/users/register/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: lowerCaseEmail }),
        }
      );

      if (response.ok) {
        console.log('Registration successful');
        setSuccess(true);
        setTimeout(() => navigate('/login'), 5000); // Redirect to login page after 5 seconds
      } else {
        const errorData = await response.json();
        console.error('Registration failed:', errorData);
        setError(errorData.email || 'Registration failed');
      }
    } catch (err) {
      console.error('Error during registration:', err);
      setError('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 2,
      }}
    >
      <Typography variant="h4" mb={2}>
        Register
      </Typography>
      {error && (
        <Typography color="error" mb={2}>
          {error}
        </Typography>
      )}
      {success && (
        <Typography color="success" mb={2}>
          Registration successful! Check your email for a password reset link. Redirecting to login...
        </Typography>
      )}
      <form onSubmit={handleRegister} style={{ width: '100%', maxWidth: '400px' }}>
        <TextField
          label="Email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value.toLowerCase())}
          fullWidth
          sx={{ mb: 2 }}
        />
        <Button variant="contained" type="submit" fullWidth>
          Register
        </Button>
      </form>
    </Box>
  );
};

export default Register;